import type { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  FontColor,
  FontWeight,
  TextAlign,
  TextSize,
} from '@freelancer/ui/text';
import { UsernameColor, UsernameSize } from '@freelancer/ui/username';
import { textVariants } from '../tailwind-text';

@Component({
  selector: 'fl-image-caption',
  template: `
    <div
      class="Text"
      [flMarginRight]="'small'"
    >
      <p
        [class]="captionClass"
        i18n="Duration and cost caption"
      >
        This {{ imageName }} cost <br />
        <ng-container *ngIf="duration > 1">
          and took {{ duration }} days to make
        </ng-container>
        <ng-container *ngIf="duration === 1">
          and took 1 day to make
        </ng-container>
      </p>
      <fl-username
        *ngIf="freelancerUsername"
        [color]="
          captionColor === FontColor.LIGHT
            ? UsernameColor.LIGHT
            : UsernameColor.DARK
        "
        [size]="UsernameSize.LARGE"
        [username]="freelancerUsername"
      ></fl-username>
    </div>
    <!-- The outer div is needed for the positioning
      of the circle to work.
    -->
    <div>
      <p class="Cost text-light text-size-inherit font-bold">
        {{ cost | flCurrency: currencyCode : { withPrecision: false } }}
      </p>
    </div>
  `,
  styleUrls: ['./image-caption.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageCaptionComponent implements OnInit, OnChanges {
  UsernameColor = UsernameColor;
  UsernameSize = UsernameSize;
  FontColor = FontColor;

  captionClass: string;

  @Input() freelancerUsername?: string;
  @Input() cost: number;
  @Input() currencyCode = 'USD';
  @Input() imageName: string;
  @Input() duration: number;
  @Input() captionColor: FontColor = FontColor.DARK;

  ngOnInit(): void {
    this.calculateStyles();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.captionColor) {
      this.calculateStyles();
    }
  }

  private calculateStyles(): void {
    this.captionClass = textVariants({
      color: this.captionColor,
      size: TextSize.MID,
      align: TextAlign.RIGHT,
      weight: FontWeight.BOLD,
      class: 'Text-desc',
    });
  }
}
